import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import { HotTable } from "@handsontable/react";
import { registerAllModules } from "handsontable/registry";
import "handsontable/dist/handsontable.full.min.css";
import fileUrl from "./dummy.xlsx";
import { useRecoilState } from "recoil";
import { excelTableHandlers, excelUrlRecoil } from "store/atom";
import styles from "./styles.module.scss";
import {
  DownloadIcon,
  FilesAttachedIcon,
  FilesTableIcon,
  SaveFileIcon,
} from "icons";
import { UseLazyApiCallV2 } from "hooks";
import { useParams } from "react-router-dom";
import axios from "axios";
import { message, Spin, Tooltip } from "antd";
import { useCurrentUserContext } from "providers";
import { UseExcelFile } from "hooks/use-excel-file";
import Handsontable from "handsontable";

// register Handsontable's modules
registerAllModules();

export function ExcelViewer({
  fieldName,
  refetchFieldHistory,
  isExcelFileChanged,
  setIsExcelFileChanged,
  tableData,
}) {
  const hotRef = useRef(null);
  const [excelHandlers, setExcelHandlers] = useRecoilState(excelTableHandlers);

  const {
    handleExport,
    excelFileLoading,
    loadingExcel,
    uploadingExcel,
    // hotRef,
    initialDataRef,
    normalizeData,
    data,
    mergedCells,
    loadExcel,
  } = UseExcelFile({ setIsExcelFileChanged, hotRef, refetchFieldHistory });

  useEffect(() => {
    setExcelHandlers({
      handleExport,
      loadExcel,
    });
  }, [data]);

  const [excelUrlState, setExcelUrlState] = useRecoilState(excelUrlRecoil);
  const { caseId } = useParams();
  const { user } = useCurrentUserContext();

  const icons = [
    {
      key: "Download",
      icon: DownloadIcon,
      clickHandler: () => handleExport("download"),
    },
    {
      key: "Save",
      icon: SaveFileIcon,
      clickHandler: async () => {
        handleExport("save");
      },
    },
  ];

  return (
    <div style={{ padding: "0px" }}>
      <Spin spinning={excelFileLoading || uploadingExcel || loadingExcel}>
        <div className={styles.icons}>
          {icons.map((item) => (
            <Tooltip title={item.key}>
              <div
                key={item.key}
                className={styles.singleIcon}
                onClick={item.clickHandler}
              >
                <item.icon />
              </div>
            </Tooltip>
          ))}
        </div>
        <div style={{ width: "100%" }}>
          <HotTable
            // afterChangesObserved={() => setIsExcelFileChanged(true)}
            afterChange={(changes, source) => {
              // Ignore changes triggered by initial load or programmatic setData
              if (source === "loadData" || !changes) return;
              if (!hotRef.current?.hotInstance) return;
              if (!initialDataRef.current) return;

              const currentData = hotRef.current.hotInstance.getData();
              const currentSnapshot = JSON.stringify(
                normalizeData(currentData),
              );

              const isChanged = currentSnapshot !== initialDataRef.current;

              setIsExcelFileChanged(isChanged);
            }}
            // themeName="ht-theme-main"
            data={data}
            ref={hotRef}
            colHeaders={true}
            rowHeaders={true}
            width="100%"
            height="710"
            stretchH="all"
            licenseKey="non-commercial-and-evaluation"
            autoWrapRow={true}
            autoWrapCol={true}
            contextMenu={true}
            manualRowMove={true}
            // colWidths={150}
            mergeCells={mergedCells} // Apply merged cells
            cells={(row, col) => {
              const cellProperties = {};

              cellProperties.renderer = function (...args) {
                Handsontable.renderers.TextRenderer.apply(this, args);

                const [, td, r, c, , value] = args;

                if (r === 0) {
                  td.style.fontWeight = "bold";
                }

                if (r === 1) {
                  td.style.backgroundColor = "lightgrey";
                  td.style.fontWeight = "bold";
                  td.style.textAlign = "center";
                  td.style.padding = "0px 30px";
                }

                if (typeof value === "number") {
                  td.style.textAlign = "right";
                }
              };

              return cellProperties;
            }}
          />
        </div>
      </Spin>
    </div>
  );
}
